export const messages = {
  escapeHTMLButtonLabel: {
    id: 'authoring.texteditor.codeEditor.escapeHTMLButton',
    defaultMessage: 'Unescape HTML Literals',
    description: 'Label For escape special html charectars button',
  },
};

export default messages;
